/* GENERATED by scripts/merch-pipeline/build-merch-data.js — do not edit by hand. */
/* Source: scripts/merch-pipeline/data/*.json */
window.CK_MERCH_CARDS_BY_BRAND = {
  "muk": [
    {
      "type": "pullquote",
      "size": "2x1",
      "quotes": [
        {
          "lines": [
            "Beauty",
            "is a ritual"
          ],
          "credit": "Issue No. 04"
        },
        {
          "lines": [
            "Life imitates art,",
            "art imitates beauty."
          ],
          "credit": "Issue No. 05"
        }
      ]
    }
  ]
};
